/**
 * スクロールしたら、指定したターゲットにクラスを付与
 */

export default class ScrollAddClass {
  constructor() {
    this.targetElements = document.querySelectorAll('[data-scroll-add-class]');
    this.options = {
      root: null,
      rootMargin: '0px 0px -200px 0px',
      threshold: 0,
    };
  }

  callback(entries, observer) {
    entries.forEach((entry) => {
      // スクロール量が、テキスト要素の座標を超えたら表示
      if (entry.isIntersecting) {
        entry.target.classList.add('is-animated');
      }
    });
  }

  setObserve() {
    const observer = new IntersectionObserver(this.callback, this.options);
    this.targetElements.forEach((targetElement) => {
      observer.observe(targetElement);
    });
  }

  init() {
    if (!this.targetElements.length) return;
    this.setObserve();
  }
}
